module.exports = __webpack_public_path__ + "static/foto-servicios-fa98143774781c9b6739dc7c8782affa.webp";